/**
 * Persists the public offline signer address (gas payer) per logged-in user in localStorage.
 * Safe to store: it is not a private key.
 */
const STORAGE_KEY = 'ping.prefs.offlineSignerByUser';

const isBrowser = typeof window !== 'undefined';

function readMap() {
  if (!isBrowser) return {};
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw && typeof raw === 'string' ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeMap(map) {
  if (!isBrowser) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch (e) {
    console.warn('Failed to persist offline signer address', e);
  }
}

/** @param {string | null | undefined} userId */
export function getOfflineSignerAddressForUser(userId) {
  if (!userId) return '';
  const map = readMap();
  const v = map[String(userId)];
  return typeof v === 'string' ? v.trim() : '';
}

/**
 * @param {string | null | undefined} userId
 * @param {string} address — trimmed; empty removes stored value for user
 */
export function setOfflineSignerAddressForUser(userId, address) {
  if (!userId) return;
  const map = readMap();
  const trimmed = String(address ?? '').trim();
  if (!trimmed) {
    delete map[String(userId)];
  } else {
    map[String(userId)] = trimmed;
  }
  writeMap(map);
}
